// Diverse collection of first names for candidate generation
// Gender-neutral approach: just "first names" without categorization

export const FIRST_NAMES: string[] = [
  // Common English names
  'James',
  'Mary',
  'John',
  'Patricia',
  'Robert',
  'Jennifer',
  'Michael',
  'Linda',
  'William',
  'Elizabeth',
  'David',
  'Barbara',
  'Richard',
  'Susan',
  'Joseph',
  'Jessica',
  'Thomas',
  'Sarah',
  'Christopher',
  'Karen',
  'Charles',
  'Nancy',
  'Daniel',
  'Lisa',
  'Matthew',
  'Margaret',
  'Anthony',
  'Betty',
  'Mark',
  'Sandra',
  'Donald',
  'Ashley',
  'Steven',
  'Dorothy',
  'Paul',
  'Kimberly',
  'Andrew',
  'Emily',
  'Joshua',
  'Donna',

  // Modern names
  'Alexander',
  'Sophia',
  'Benjamin',
  'Isabella',
  'Samuel',
  'Olivia',
  'Nathan',
  'Emma',
  'Ryan',
  'Ava',
  'Brandon',
  'Mia',
  'Justin',
  'Charlotte',
  'Aaron',
  'Amelia',
  'Kevin',
  'Harper',
  'Brian',
  'Evelyn',
  'George',
  'Abigail',
  'Edward',
  'Chloe',
  'Ronald',
  'Grace',
  'Timothy',
  'Victoria',
  'Jason',
  'Madison',

  // Hispanic/Latino names
  'Carlos',
  'Maria',
  'Miguel',
  'Ana',
  'Luis',
  'Carmen',
  'Antonio',
  'Rosa',
  'Francisco',
  'Elena',
  'Pedro',
  'Lucia',
  'Juan',
  'Sofia',
  'Diego',
  'Isabel',
  'Alejandro',
  'Gabriela',
  'Fernando',
  'Valentina',

  // Germanic/Nordic names
  'Hans',
  'Ingrid',
  'Erik',
  'Astrid',
  'Lars',
  'Freya',
  'Klaus',
  'Greta',
  'Otto',
  'Helga',
  'Stefan',
  'Brigitte',
  'Werner',
  'Liesel',
  'Friedrich',
  'Heidi',

  // South Asian names
  'Raj',
  'Priya',
  'Amit',
  'Ananya',
  'Vikram',
  'Deepa',
  'Arjun',
  'Kavita',
  'Sanjay',
  'Lakshmi',
  'Ravi',
  'Meera',
  'Anil',
  'Neha',
  'Suresh',
  'Pooja',

  // East Asian names
  'Wei',
  'Mei',
  'Jian',
  'Ling',
  'Chen',
  'Yan',
  'Ming',
  'Xiu',
  'Yuki',
  'Sakura',
  'Kenji',
  'Hana',
  'Takeshi',
  'Aiko',
  'Hiroshi',
  'Yumi',

  // Korean names
  'Joon',
  'Soo',
  'Min',
  'Eun',
  'Hyun',
  'Ji',

  // Eastern European names
  'Ivan',
  'Natasha',
  'Dmitri',
  'Olga',
  'Sergei',
  'Katya',
  'Andrei',
  'Irina',
  'Nikolai',
  'Tatiana',
  'Alexei',
  'Elena',
  'Vladimir',
  'Anna',
  'Mikhail',
  'Maria',

  // French names
  'Pierre',
  'Marie',
  'Jacques',
  'Claire',
  'Philippe',
  'Colette',
  'Henri',
  'Margot',
  'Louis',
  'Genevieve',

  // Italian names
  'Marco',
  'Giulia',
  'Luca',
  'Francesca',
  'Giovanni',
  'Alessia',
  'Paolo',
  'Chiara',
  'Matteo',
  'Valentina',

  // Irish/Celtic names
  'Sean',
  'Siobhan',
  'Patrick',
  'Aoife',
  'Connor',
  'Niamh',
  'Liam',
  'Brigid',
  'Declan',
  'Fiona',

  // Greek names
  'Dimitri',
  'Helena',
  'Constantine',
  'Athena',
  'Nicholas',
  'Sophia',
  'Alexander',
  'Penelope',

  // Middle Eastern names
  'Omar',
  'Fatima',
  'Khalid',
  'Aisha',
  'Yusuf',
  'Layla',
  'Hassan',
  'Nadia',
  'Ibrahim',
  'Yasmin',

  // African names
  'Kwame',
  'Amara',
  'Kofi',
  'Zara',
  'Chidi',
  'Nia',
  'Jabari',
  'Imani',
  'Obi',
  'Adaeze',

  // Additional diverse names
  'Noah',
  'Ethan',
  'Mason',
  'Logan',
  'Jacob',
  'Lucas',
  'Oliver',
  'Elijah',
  'Aiden',
  'Caden',
  'Zoe',
  'Lily',
  'Hannah',
  'Natalie',
  'Samantha',
  'Allison',
  'Audrey',
  'Leah',
  'Savannah',
  'Brooklyn',
]
